import { useState, useEffect, useCallback } from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import moment from 'moment';
import PointOfContact from './PointOfContact';
import ProfileCard from './ProfileCard';
import { AlertComponent } from '../../../../../components';

export default function VendorInformation({ nextStep, ...rest }) {
  const { vendorEventPayload } = useSelector((store) => store.vendorEvents);
  const { event } = useSelector((store) => store.events);
  const [alertMessage, setAlertMessage] = useState(null);
  const [pointOfContactValues, setPointOfContactValues] = useState({
    name: '',
    email: '',
    phone_number: '',
  });

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const isExpiredDeadlineEvent = useCallback(() => {
    const strDeadlineDate = moment(event?.parameters_event?.application_deadline)
      .utc()
      .format('YYYY-MM-DD');
    const strCurrentDate = moment().format('YYYY-MM-DD');
    const currentDate = moment(strCurrentDate);
    const deadlineDate = moment(strDeadlineDate);
    // console.log('currentDate ', currentDate);
    // console.log('deadlineDate ', deadlineDate);
    return currentDate.isAfter(deadlineDate);
  }, [event?.parameters_event?.application_deadline]);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const noMoreApplicationEventAllowed = () => {
    const lengthVendors = event?.vendorEvents?.length;
    return lengthVendors >= event?.parameters_event?.max_applications;
  };

  useEffect(() => {
    if (vendorEventPayload?.vendor_event_contact) {
      setPointOfContactValues(vendorEventPayload?.vendor_event_contact);
    }
  }, [vendorEventPayload?.vendor_event_contact]);

  useEffect(() => {
    if (isExpiredDeadlineEvent()) {
      setAlertMessage(
        `The registration deadline for the event is ${moment(
          event?.parameters_event?.application_deadline,
        )
          .utc()
          .format('LL')}`,
      );
    }

    if (noMoreApplicationEventAllowed()) {
      setAlertMessage('The maximum number of allowed applications has been exceeded.');
    }
  }, [
    event?.parameters_event?.application_deadline,
    isExpiredDeadlineEvent,
    noMoreApplicationEventAllowed,
  ]);

  return alertMessage ? (
    <AlertComponent title="Registration Event" content={<p>{alertMessage}</p>} severity="warning" />
  ) : (
    <>
      <div style={{ marginBottom: '1rem' }}>
        <ProfileCard />
      </div>
      <div>
        <PointOfContact nextStep={nextStep} initialValues={pointOfContactValues} {...rest} />
      </div>
    </>
  );
}

VendorInformation.propTypes = {
  nextStep: PropTypes.func,
};

VendorInformation.defaultProps = {
  nextStep: () => {},
};
